import { TypeIcon } from 'core/types';

export const bracketRight: TypeIcon = {
  viewBox: '0 0 72 149',
  path: '<path d="M63.65 0.200195C67.45 18.618 69.35 33.3927 69.35 44.5243C69.35 59.299 65.35 75.4399 57.35 92.9469C52.25 104.18 44.9 114.654 35.3 124.368C25.4 134.488 14.35 142.432 2.15 148.2L2 147.138C22.2 135.399 38.45 116.88 50.75 91.5807C60.45 71.645 65.3 50.6973 65.3 28.7376C65.3 19.124 64.3 9.76327 62.3 0.655583L63.65 0.200195Z" />',
};
